module.exports = __webpack_public_path__ + "img/cn-bg-color.9369848.png";